<template>
  <aside
    :class="[
      'sidebar',
      `sidebar--${position}`,
    ]"
  >
    <div class="sidebar__container">
      <slot name="content" />
    </div>
  </aside>
</template>

<script>
export default {
  name: 'AppSidebar',

  props: {
    position: {
      type: String,
      required: false,
      default: 'left',
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~sass-mq/mq";

.sidebar {
  position: fixed;

  color: $color-gray;

  pointer-events: none;
  z-index: z-index(header);

  @include mq($and: $is-not-touch-device) {
    .sidebar__container {
      transition: height 0.3s $inOutQuad;
    }

    &:hover .sidebar__container {
      height: 120px;
    }
  }

  &--left {
    top: 0;
    left: 0;
  }

  &--right {
    bottom: 0;
    right: 0;
  }

  @include mq($until: ipadL) {
    width: 100%;

    .sidebar__container {
      height: auto;
      width: 100%;
      padding: 12px 18px 15px 13px;
    }
  }

  @include mq(ipadL) {
    height: 100%;

    .sidebar__container {
      height: 100px;
      padding: 0 9vh;
    }


    &--left {
      transform: rotate(-90deg);

      .sidebar__container {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }

    &--right {
      transform: rotate(90deg);

      .sidebar__container {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  &__container {
    position: relative;
    width: calc(var(--vh, 1vh) * 100);

    pointer-events: auto;
    background-color: $color-white;
  }
}
</style>
